import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=6e271ca8&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=6e271ca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e271ca8",
  null
  
)

export default component.exports